var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24ArrowLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 11H7.135l3.633-4.36c.354-.424.296-1.055-.128-1.408-.425-.354-1.055-.296-1.408.128l-5 6c-.039.047-.059.102-.088.154-.024.042-.053.078-.071.124-.045.115-.072.236-.072.358L4 12l.001.004c0 .122.027.243.072.358.018.046.047.082.071.124.029.052.049.107.088.154l5 6c.198.237.482.36.768.36.226 0 .453-.076.64-.232.424-.353.482-.984.128-1.408L7.135 13H19c.552 0 1-.448 1-1s-.448-1-1-1",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24ArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon _ 24_ arrow-left.0327ca53.svg";
export { ForwardRef as ReactComponent };